import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const CazebooLogo = (props) => {
  const themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        id="Cazeboo"
        data-name="Cazeboo"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 356.82 50"
        strokeWidth={0}
        fill="currentColor"
      >
        <path
          fill={themeColor === 'light' ? '#4d4b4b' : '#fff'}
          d="m0,25C0,11.26,10.52,1.51,24.84,1.51c8.32,0,15.03,3.03,19.42,8.52l-8.13,7.36c-2.84-3.42-6.32-5.29-10.65-5.29-7.42,0-12.58,5.16-12.58,12.9s5.16,12.9,12.58,12.9c4.32,0,7.81-1.87,10.65-5.29l8.13,7.36c-4.39,5.48-11.1,8.52-19.42,8.52C10.52,48.49,0,38.74,0,25Z"
        />
        <path
          fill={themeColor === 'light' ? '#4d4b4b' : '#fff'}
          d="m147.78,37.45v10.13h-40.45v-8l22.78-27.03h-22.19V2.42h38.91v8l-22.78,27.03h23.74Z"
        />
        <path
          fill={themeColor === 'light' ? '#4d4b4b' : '#fff'}
          d="m245.22,35.19c0,7.81-6.45,12.39-18.58,12.39h-24.39V2.42h23.1c11.87,0,17.68,4.84,17.68,11.81,0,4.32-2.19,7.81-6.06,9.81,5.1,1.81,8.26,5.68,8.26,11.16Zm-30.32-23.55v8.71h8.77c4.26,0,6.45-1.48,6.45-4.39s-2.19-4.32-6.45-4.32h-8.77Zm17.42,22.13c0-3.1-2.32-4.58-6.71-4.58h-10.71v9.16h10.71c4.39,0,6.71-1.48,6.71-4.58Z"
        />
        <path
          fill={themeColor === 'light' ? '#4d4b4b' : '#fff'}
          d="m250.82,25c0-13.55,10.65-23.49,25.1-23.49s25.1,9.94,25.1,23.49-10.65,23.49-25.1,23.49-25.1-9.94-25.1-23.49Zm37.29,0c0-7.81-5.36-12.9-12.19-12.9s-12.19,5.1-12.19,12.9,5.36,12.9,12.19,12.9,12.19-5.1,12.19-12.9Z"
        />
        <path
          fill={themeColor === 'light' ? '#4d4b4b' : '#fff'}
          d="m306.62,25c0-13.55,10.65-23.49,25.1-23.49s25.1,9.94,25.1,23.49-10.65,23.49-25.1,23.49-25.1-9.94-25.1-23.49Zm37.29,0c0-7.81-5.36-12.9-12.19-12.9s-12.19,5.1-12.19,12.9,5.36,12.9,12.19,12.9,12.19-5.1,12.19-12.9Z"
        />
        <g>
          <rect
            fill="#38A0AD"
            x="158.96"
            y="2.42"
            width="36.08"
            height="11.32"
            rx="5.14"
            ry="5.14"
          />
          <rect
            fill="#38A0AD"
            x="148.05"
            y="19.34"
            width="35.22"
            height="11.32"
            rx="5.14"
            ry="5.14"
          />
          <rect
            fill="#38A0AD"
            x="160.49"
            y="36.26"
            width="36.08"
            height="11.32"
            rx="5.14"
            ry="5.14"
          />
        </g>
        <path
          fill={themeColor === 'light' ? '#4d4b4b' : '#fff'}
          d="m85.21,38.81h-19.1l-3.55,8.77h-13.03L69.47,2.42h12.58l20,45.16h-13.29l-3.55-8.77Zm-3.74-9.42l-5.81-14.45-5.81,14.45h11.61Z"
        />
      </svg>
    </SvgIcon>
  );
};

export default CazebooLogo;
